import { createStyles, Theme } from '@material-ui/core'

export const emptyDataStyles = (theme: Theme) =>
  createStyles({
    root: {
      textAlign: 'center'
    },
  })